import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../assets/styles/style.css";
import logoutIcon from "../../assets/icons/logout-icon.svg";
import AuthService from "../../services/AuthServices";
import Booking from "../../assets/icons/booking";
import { FaHome } from "react-icons/fa";
import Braiding from "../../assets/icons/braiding";
import { colors } from "../../assets/config/color";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FaUserCircle } from "react-icons/fa";
const Sidebar = () => {
  const location = useLocation();
  const [activeScreen, setActiveScreen] = useState("/");
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  useEffect(() => {
    setActiveScreen(location.pathname);
  }, [location.pathname]);

  const navigate = useNavigate();

  const handleLogout = () => {
    AuthService.logout();
    navigate("/");
  };

  return (
    <div id="sidebar">
      <MenuItem
        path="/homeUser"
        icon={
          <FaHome
            size={isSmallScreen ? 15 :20}
            style={{
              color: activeScreen === "/homeUser" ? colors.gold : colors.gris,
            }}
          />
        }
        text="myHome"
        active={activeScreen === "/homeUser"}
      />
      <MenuItem
        path="/styles"
        icon={
          <Braiding
          width={isSmallScreen ? 20 :35}
          height={isSmallScreen ? 20 :35}
          fill={activeScreen === "/styles" ? colors.gold : colors.gris}
          />
        }
        text="Styles"
        active={activeScreen === "/styles"}
      />
      <MenuItem
        path="/bookingUser"
        icon={
          <Booking
          width={isSmallScreen ? 15 :24}
          height={isSmallScreen ? 15 :24}
          fill={activeScreen === "/bookingUser" ? colors.gold : colors.gris}
          />
        }
        text="myBookings"
        active={activeScreen === "/bookingUser"}
      />
      <div style={{ marginTop: "auto" }}>
        <div className="item-menu item-menunotfocus photo">
        <FaUserCircle size={45}  color={colors.gris}/>
        </div>
        <div
          className="item-menu item-menunotfocus logout"
          onClick={handleLogout}
        >
          <img src={logoutIcon} alt="" />
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
};

const MenuItem = ({ path, icon, text, active }) => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div
      className={`item-menu ${active ? "item-menufocus" : "item-menunotfocus"}`}
      onClick={() => handleNavigation(path)}
    >
      {icon}
      <span style={{ color: active ? colors.gold : "" }}>{text}</span>
    </div>
  );
};

export default Sidebar;
